import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const CreateReels = async (payload) => {
  try {
    const response = await APIs.post('/create_reel', payload);

    if (response?.data?.message === 'success') {
      toast('Created Successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllReels = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_all_reels/${payload.page}/${payload.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllMajorReels = async () => {
  try {
    const response = await APIs.get(`/get_all_major_reels`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const uploadReelsImage = async (payload) => {
  try {
    const response = await APIs.post(`/upload_through_cloudinary`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully uploaded');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const uploadReelsIcon = async (payload) => {
  try {
    const response = await APIs.post(`/upload_through_cloudinary`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully uploaded');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const DeleteReels = async (payload) => {
  try {
    const response = await APIs.post(`/delete_reels`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully deleted');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getSingleReelsDetails = async (payload) => {
  try {
    const response = await APIs.get(`/get_single_reels/${payload?.Id}`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const EditReels = async (payload) => {
  try {
    const response = await APIs.patch(`/edit_reels/${payload?._id}`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const SearchForReelsByTitle = async (payload) => {
  try {
    const response = await APIs.get(
      `/search_for_reels_by_title/${payload?.name}/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const ReelsServices = {
  CreateReels,
  getAllReels,
  getAllMajorReels,
  uploadReelsImage,
  uploadReelsIcon,
  DeleteReels,
  getSingleReelsDetails,
  EditReels,
  SearchForReelsByTitle,
};

export default ReelsServices;
